import { openBlock as o, createElementBlock as t, createElementVNode as n } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(d, e) {
  return o(), t("svg", l, [...e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      d: "m12 16-5-5 1.4-1.45 2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-8 4v-5h2v3h12v-3h2v5z"
    }, null, -1)
  ])]);
}
const c = { render: r };
export {
  c as default,
  r as render
};
